import PropTypes from 'prop-types';
import React, { useEffect, useRef } from 'react';

const OutsideClickHandler = ({ triggerRef, className, children, callback }) => {
	const ref = useRef(null);
	const handleClickOutside = event => {
		if (
			ref.current &&
			!ref.current.contains(event.target) &&
			(triggerRef === null || (triggerRef.current && !triggerRef.current.contains(event.target)))
		) {
			callback(event);
		}
	};

	useEffect(() => {
		document.addEventListener('click', handleClickOutside);
		return () => {
			document.removeEventListener('click', handleClickOutside);
		};
	});

	return (
		<div ref={ref} className={className}>
			{children}
		</div>
	);
};

OutsideClickHandler.propTypes = {
	callback: PropTypes.func,
	triggerRef: PropTypes.object,
	children: PropTypes.node.isRequired,
	className: PropTypes.string
};

OutsideClickHandler.defaultProps = {
	callback: () => {},
	triggerRef: null,
	className: 'outsideClickHandler'
};

export default OutsideClickHandler;
